import React from 'react';
import { Box, Divider, List, ListItem, ListItemText, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import { useIntl } from 'react-intl';

import AttachmentLink from '../../Posts/Shared/AttachmentLink';
import { moment } from '../../../I18n';
import LocationLink from '../../Maps/LocationLink';

function AnswerLabel({ answer }: any) {
  const intl = useIntl();

  if (answer.lat) {
    return <LocationLink item={{ ...answer, label: answer?.content }} />;
  }

  if (answer.date) {
    return moment(answer.date).format(intl.formatMessage({ id: 'MOMENT.DATE.DEFAULT' }));
  }

  return <Typography dangerouslySetInnerHTML={{ __html: answer.content }} />;
}

function hasDisplayableContent(answer: any) {
  return answer.date || answer.lat || answer?.attachments?.length > 0 || !isEmpty(answer.content);
}

function Answers({ questionId, answers }: any) {
  return (
    <List
      sx={{
        overflowY: 'scroll',
        maxHeight: 400,
        marginTop: 3,
        '::-webkit-scrollbar': {
          width: '5px',
        },
        '::-webkit-scrollbar-thumb': {
          borderRadius: '5px',
          backgroundColor: (theme) => theme.palette.grey[500],
        },
      }}
    >
      {answers.filter(hasDisplayableContent).map((answer: any, index: number) => (
        <li key={`${questionId}-${answer.id}`}>
          {answer?.attachments?.length > 0 && (
            <Box role="list" sx={{ mt: 2 }}>
              {answer.attachments.map((attachment: any) => (
                <Box key={attachment.url} role="listitem" sx={{ mt: 2 }}>
                  <AttachmentLink attachment={attachment} />
                </Box>
              ))}
            </Box>
          )}

          <ListItem component="span">
            <ListItemText
              primary={<AnswerLabel answer={answer} />}
              secondary={moment(answer.created_at).fromNow()}
              sx={{ wordBreak: 'break-word' }}
            />
          </ListItem>

          {answers.length > index + 1 && <Divider sx={{ my: 1 }} />}
        </li>
      ))}
    </List>
  );
}

export default Answers;
